<app-modal
  [isSmall]="true"
  [isActive]="this.showSessionAlert && !isDashboard()"
  [showAcceptFooter]="false"
  [showCloseFooter]="false"
  [showClose]="false"
  [acceptFooterDisabled]="false"
  (modalState)="closeSessionAlert()"
  (acceptState)="closeSession()"
>
  <div modal-content class="end-action">
    <div>
      <span>
        {{ 'auth.session.inactivity-detected' | translate }}
        {{ 'auth.session.close-session-question' | translate }}
      </span>
    </div>
    <div>
      <app-checkbox
        [isChecked]="false"
        (checked)="checkedCloseSession($event)"
        id="close-session-inactivity"
        side="left"
        size="1.1em"
        label="{{ 'auth.session.close-session-check' | translate }}"
        [checkboxVisible]="true"
        [labelVisible]="true"
        [bold]="false"
        textForm="none"
      ></app-checkbox>
    </div>
    <div>
      <app-input-submit
        [isDanger]="true"
        [disabled]="!wantToCloseSession"
        inputText="{{ 'shared.closePnr' | translate }}"
        type="submit"
        (clickButton)="closeSession()"
      ></app-input-submit>
    </div>
    <div>
      <span class="green-text">{{ 'auth.session.esc-to-continue' | translate }}</span>
    </div>
  </div>
</app-modal>
